import React from "react";
import { useLanguageBasedFont } from "../../../../templates/monotone/const/font-utils";

export const ChanelInvalidPage = () => {
  const fontClass = useLanguageBasedFont();

  return (
    <div
      className={`bg-white flex items-center justify-center p-4 ${fontClass}`}
      style={{ height: window.innerHeight }}
    >
      <div className="px-[40px] relative flex flex-col items-center justify-center gap-[40px] bg-[#F2F2F2] rounded-3xl max-w-md w-full h-[90%] max-h-[638px] p-8 text-center">
        <div className="w-full text-left space-y-4">
          <div>
            お客様のご視聴可能な時間は終了いたしました。
            <br />
            ご利用ありがとうございました。
          </div>
          <div>
            Your session has ended.
            <br />
            Thank you for your time.
          </div>
        </div>
      </div>
    </div>
  );
};
